import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { GlobalAdminEnforcementGuard } from '~admin/app/services/global-admin-enforcement/global-admin-enforcement.guard'

/*
 * FTR Web App Imports
 */
import { SyncGuard } from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'
import { AuthenticationGuard } from '@ftr/ui-user'
import { HelpPageModule } from '~app/pages/help/help-page.module'
import { MultifactorAuthenticationPagesModule } from '~app/pages/multifactor-authentication/multifactor-authentication-pages.module'
import { NotFoundPage } from '~app/pages/not-found.page'
import { PasswordResetPagesModule } from '~app/pages/password-reset/password-reset-pages.module'
import { RootModule } from '~app/pages/root.module'
import { SignupPagesModule } from '~app/pages/signup/signup-pages.module'

@NgModule({
  imports: [
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
    HelpPageModule,
    MultifactorAuthenticationPagesModule,
    RouterModule.forRoot([
      {
        path: AppPaths.DefaultPage,
        canActivate: [SyncGuard],
        data: {
          breadcrumb: 'Home',
          title: 'Home',
          syncGuards: [AuthenticationGuard, GlobalAdminEnforcementGuard],
        },
        children: [
          {
            path: AppPaths.DefaultPage,
            redirectTo: AppPaths.Admin,
            pathMatch: 'full',
          },
          {
            path: AppPaths.Admin,
            loadChildren: () =>
              import('~admin/app/pages/admin/global-admin-pages.module').then(m => m.GlobalAdminPagesModule),
          },
        ],
      },
      {
        path: '**',
        component: NotFoundPage,
        canActivate: [AuthenticationGuard, GlobalAdminEnforcementGuard],
      },
    ]),
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
